import script from "./ZertifikatIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ZertifikatIndex.vue?vue&type=script&setup=true&lang=js"

import "./ZertifikatIndex.vue?vue&type=style&index=0&id=703f19d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-703f19d9"]])

export default __exports__